module.exports = __webpack_public_path__ + "static/media/reset-nfg.069647d4.svg";